import * as React from "react";

import BaseCalendarView, {
  type BaseCalendarViewProps,
  type CalendarWithOptionalHeaderViewProps,
  type SingleSelectionCalendarViewProps,
} from "./BaseCalendarView";
import Calendar from "./Calendar";
import Body from "./CalendarBody/Body";
import Header, { type HeaderProps } from "./CalendarHeader/Header";

export const MONTH_CALENDAR_ROW_WIDTH = 3;

type MonthViewProps = BaseCalendarViewProps &
  SingleSelectionCalendarViewProps &
  CalendarWithOptionalHeaderViewProps;

class MonthView extends BaseCalendarView<MonthViewProps, any> {
  public render() {
    const {
      values,
      hasHeader,
      onValueClick,
      onNextPageBtnClick,
      onPrevPageBtnClick,
      hasPrevPage,
      hasNextPage,
      onHeaderClick,
      disabledItemIndexes,
      activeItemIndex,
      currentHeadingValue,
      onCellHover,
      hoveredItemIndex,
      onMount,
      inline,
      localization,
      ...rest
    } = this.props;
    const headerProps: HeaderProps = {
      className: "suicr-month-view-header",
      onNextPageBtnClick,
      onPrevPageBtnClick,
      hasPrevPage,
      hasNextPage,
      onHeaderClick,
      title: currentHeadingValue,
      displayWeeks: false,
      width: MONTH_CALENDAR_ROW_WIDTH,
      localization,
    };

    return (
      <Calendar
        ref={(e) => {
          this.calendarNode = e;
        }}
        outlineOnFocus={inline}
        {...rest}
      >
        {hasHeader && <Header {...headerProps} />}
        <Body
          width={MONTH_CALENDAR_ROW_WIDTH}
          data={values}
          onCellClick={onValueClick}
          onCellHover={onCellHover}
          active={activeItemIndex}
          hovered={hoveredItemIndex}
          disabled={disabledItemIndexes}
        />
      </Calendar>
    );
  }
}

export default MonthView;
